import { Box, Card } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import HeaderLine from 'src/Common/ui/HeaderLine'
import SelectInput from 'src/Common/ui/selectInput'
import { ACCEPTANCE_ID, MITITGATION_APPROACH, REDUCTION_ID } from 'src/Entities/RiskTypes'
import Justification from './MitigationComponents/Justification'
import Input from 'src/Common/ui/input'
import { inputValidation } from 'src/lib/utils'
import { t } from 'i18next'
import Tasktable from './MitigationComponents/Tasktable'
import Assessors from './MitigationComponents/Assessors'
import { useGovernanceStore } from '../Onboarding/Store/GovernanceStore'
import { useRiskStore } from './Store/RiskStore'
import { createMitigationPlan } from 'src/API/RiskAPI'
import { RxCross2 } from 'react-icons/rx'
import { LiaSaveSolid } from 'react-icons/lia'
import { Button } from '../../Common/ui/button'
import { toast } from 'react-toastify'
import DatePickerInput from 'src/Common/ui/DatePickerInput'

const MitigationEdit = ({ setIsEditTrue }) => {
    const { control, errors } = useForm()
    const { RiskDetailsById } = useRiskStore()
    const [ getData, setGetData ] = useState({})
    useEffect(() => {
        if (RiskDetailsById?.mitigation) {
            const data = RiskDetailsById?.mitigation
            if (data?.taskLists?.length === 0 || !data?.taskLists) {
                data.taskLists = RiskDetailsById?.riskInformation?.suggestedMitigation
            }
            setGetData(data)
            getDepOrganizations(orgId)
        }
    }, [RiskDetailsById])
    const onValueSelectChange = (key, value) => {
        if (key === 'approachId') {
            const data = getData
            if (data?.taskLists?.length === 0) {
                data.taskLists = RiskDetailsById?.riskInformation?.suggestedMitigation
            }
            setGetData({ ...data, [key]: value })
        } else {
            setGetData({ ...getData, [key]: value })
        }
    }
    const onInputChange = (key, e) => {
        setGetData({ ...getData, [key]: e.target.value })
    }
    const taskSelectChange = (value, index, dateType) => {
        setGetData({
            ...getData,
            taskLists: getData.taskLists.map((item, i) => {
                if (i === index) {
                    item[dateType] = value
                }
                return item
            })
        })
    }
    const taskInputChange = (e, index, dateType) => {
        setGetData({
            ...getData,
            taskLists: getData.taskLists.map((item, i) => {
                if (i === index) {
                    item[dateType] = e
                }
                return item
            })
        })
    }
    const userId = localStorage.getItem('userId')

    const handleAddTask = () => {
        const addData = getData.taskLists
        addData.push({
            id: 0,
            riskId: RiskDetailsById?.riskInformation?.id,
            name: '',
            startDate: null,
            endDate: null,
            departmentId: null,
            responsible: '',
            actions: null,
            createdBy: userId,
            status: 11,
            createdAt: new Date().toISOString(),
            modifiedBy: userId,
            modifiedAt: new Date().toISOString()
        })
        setGetData({
            ...getData,
            taskLists: addData
        })
    }
    const handleDeleteTask = (index) => {
        setGetData({
            ...getData,
            taskLists: getData.taskLists.filter((item, i) => i !== index)
        })
    }
    const { getDepOrganizations, allDepartments } = useGovernanceStore()
    const { getRidkDetailsById } = useRiskStore()
    const [ departments, setDepartments ] = useState([])
    const orgId = localStorage.getItem('orgId')
    const [ loading, setLoading ] = useState(false)
    useEffect(() => {
        if (allDepartments?.length > 0) {
            setDepartments(allDepartments)
        }
    }, [allDepartments])
    useEffect(() => {
        getDepOrganizations(orgId)
    }, [])
    const onSubmit = (message) => {
        setLoading(true)
        const data = JSON.parse(JSON.stringify(getData))
        if (data.approachId === REDUCTION_ID) {
            data.createTasks = { riskId: RiskDetailsById?.riskInformation?.id, riskScore: RiskDetailsById?.analyzeResponse?.qualitativeRiskAssessment, taskListRequests: getData.taskLists }
            data.availableAmount = +data.availableAmount || 0
            data.mitigationBudget = +data.mitigationBudget
        }
        data.riskId = RiskDetailsById?.riskInformation?.id
        data.modifiedBy = userId
        delete data.scoring
        delete data.taskLists
        delete data.modifiedAt
        createMitigationPlan(data).then((res) => {
            if (res?.data) {
                toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{message.replace('[ID]', RiskDetailsById?.riskInformation?.referenceId)}</p></p>, {
                    position: 'top-right', theme: 'light'
                })
                getRidkDetailsById(Number(RiskDetailsById?.riskInformation?.id), userId)
                setIsEditTrue(false)
                setLoading(false)
            } else {
                toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>End Date should be lesser than Resolution Date</p></p>, {
                    position: 'top-right', hideProgressBar: true, theme: 'light'
                })
                setLoading(false)
            }
        })
    }

    const handleCancel = () => {
        setIsEditTrue(false)
    }

    return (

        <div className='h-[100%] w-[100%]'>
            <Card className="flex flex-col h-[100%] gap-4 p-4 flex-shrink-0">
                <div className='h-[90%] px-2 !overflow-scroll'>
                    <HeaderLine text={'Mitigation Plan'} />
                    <Box display="grid" sx={{ pt: 2 }} gridTemplateColumns="1fr 3fr" gap={2}>
                        <Box gridColumn="span 1">
                            <SelectInput
                                label={'Approach'}
                                control={control}
                                errors={errors}
                                name="category"
                                placeholder="Select"
                                onValueChange={(value) => onValueSelectChange('approachId', value)}
                                value={getData.approachId}
                                defaultValue={getData.approachId}
                                options={MITITGATION_APPROACH}
                            />
                        </Box>
                        <Box gridColumn="span 1">
                            <Justification control={control} reviewDate={getData?.reviewDate} data={getData?.justification} onInputChange={onValueSelectChange} type={getData?.approachId} errors={errors}/>
                        </Box>
                    </Box>
                    <Box display="grid" sx={{ pb: 2 }} gridTemplateColumns="repeat(4, 1fr)" gap={2}>
                        {getData.approachId === REDUCTION_ID && <>
                            <Box gridColumn="span 1">
                                <Input
                                    errors={errors}
                                    control={control}
                                    rules={{
                                        validate: (value) => {
                                            return inputValidation(value, value?.length < 251, t('This field is required'), t('Characters should be less than 250'))
                                        }
                                    }}
                                    name='breif-description'
                                    label={t('Mitigation Budget')}
                                    placeholder="Enter Mitigation Budget"
                                    type="number"
                                    onValueChange={(e) => onInputChange('mitigationBudget', e)}
                                    value={getData?.mitigationBudget}
                                    maxLength={250}
                                />
                            </Box>
                            {/* <Box gridColumn="span 1">
                                <Input
                                    errors={errors}
                                    control={control}
                                    rules={{
                                        validate: (value) => {
                                            return inputValidation(value, value?.length < 251, t('This field is required'), t('Characters should be less than 250'))
                                        }
                                    }}
                                    name='breif-description'
                                    label={t('Available Amount')}
                                    placeholder="Enter Available Amount"
                                    type="number"
                                    onValueChange={(e) => onInputChange('availableAmount', e)}
                                    value={getData?.availableAmount}
                                    maxLength={250}
                                />
                            </Box> */}
                        </>}
                    </Box>
                    {
                        getData.approachId === REDUCTION_ID && <>
                            <HeaderLine text={'Task List'} />
                            <div className='py-4'>
                                <Assessors data={RiskDetailsById?.analyzeResponse?.qualitativeRiskAssessment} />
                            </div>
                            <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" sx={{ py: 2 }} gap={2}>
                                {
                                    getData.approachId === REDUCTION_ID && <Controller name="actions"
                                        rules={getData.type === ACCEPTANCE_ID ? { required: 'This field is Required' } : {}}
                                        control={control}
                                        errors={errors}
                                        render={({ field: { onChange } }) => (<Box gridColumn="span 1">
                                            <DatePickerInput
                                                label={'Resolution Date'}
                                                name={'selectedDate'}
                                                required
                                                className={'input-grc'}
                                                value={getData?.resolutionDate}
                                                errors={errors}
                                                control={control}
                                                // minDate={item?.startDate || ''}
                                                // maxDate={fromMaxDate}
                                                // name="selectedDate"
                                                onValueChange={(e) => {
                                                    const val = e
                                                    onValueSelectChange('resolutionDate', val)
                                                    onChange(val)
                                                }}
                                            />
                                        </Box>)}
                                    />
                                }
                            </Box>
                            <Tasktable handleAddTask={handleAddTask} handleDeleteTask={handleDeleteTask} taskInputChange={taskInputChange} taskSelectChange={taskSelectChange} data={getData?.taskLists} departments={departments} control={control} errors={errors} />
                        </>
                    }
                </div>
                {getData.approachId !== null && <div className="h-[10%] flex justify-end items-center space-x-4">
                    <Button
                        onClick={() => handleCancel()}
                        variant='outline'
                        style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                    >
                        <RxCross2 className="mr-2" size={18} /> {t('Cancel')}
                    </Button>
                    <Button onClick={() => onSubmit('Mitigation stage has been completed for Risk [ID]')} disabled={loading}>
                        <LiaSaveSolid className="mr-2" size={15} /> Save
                    </Button>
                </div>}
            </Card>
        </div>
    )
}

export default MitigationEdit
